/* corex-textil-editor-text.js · Panel del texto seleccionado del personalizador de camisetas: contenido, fuente
   (botones escritos con su propia tipografía; 8 a la vista y el resto al desplegar) y color (muestras + HEX).
   attach(ed) recibe del editor: root, selected(), patchLayer(id, patch), fontLoaded(), announce(msg). */
(function (global) {
  'use strict';

  var QUICK_COLORS = ['#FFFFFF', '#141414', '#E2211C', '#E9B931', '#3E8ED0', '#2F5D3A'];

  /* "#E2211C", "E11D2E" o "#fff" → "#E2211C" / "#FFFFFF"; null si no es un color HEX. */
  function parseHex(raw) {
    var v = String(raw == null ? '' : raw).trim().replace(/^#/, '');
    if (/^[0-9a-f]{3}$/i.test(v)) v = v.split('').map(function (c) { return c + c; }).join('');
    return /^[0-9a-f]{6}$/i.test(v) ? '#' + v.toUpperCase() : null;
  }
  /* Color de una capa (#rrggbb del selector antiguo o del HEX) en mayúsculas para compararlo. */
  function normalize(c) { return parseHex(c) || '#141414'; }

  function attach(ed) {
    var F = global.CorexTextilFonts, UI = global.CorexTextilUI;
    var q = function (s) { return ed.root.querySelector(s); };
    var panel = q('[data-cte-textp]'), fontsBox = q('[data-cte-fonts]'), allBtn = q('[data-cte-fonts-all]');
    var hex = q('[data-cte-hex]'), hexMsg = q('[data-cte-hex-msg]'), chip = q('[data-cte-hex-chip]');
    var showAll = false, previews = {}, fontsKey = '';

    function loadPreviews(keys) {
      keys.forEach(function (k) {
        if (previews[k]) return;
        previews[k] = F.loadPreview(k).catch(function () { delete previews[k]; });
      });
    }
    function renderFonts(selKey) {
      var key = selKey + '|' + showAll;
      if (key === fontsKey) return;
      fontsKey = key;
      var list = F.FONTS.map(function (f) {
        return { key: f.key, name: f.name, weight: f.weight, previewFamily: F.previewFamily(f.key), quick: F.QUICK.indexOf(f.key) !== -1 };
      });
      fontsBox.innerHTML = UI.fonts(list, selKey, showAll);
      loadPreviews(list.filter(function (f) { return showAll || f.quick || f.key === selKey; }).map(function (f) { return f.key; }));
      allBtn.textContent = showAll ? 'Ver menos fuentes ▴' : 'Ver las ' + F.FONTS.length + ' fuentes ▾';
      allBtn.setAttribute('aria-expanded', String(showAll));
    }
    function setHexMsg(text) {
      hexMsg.hidden = !text;
      hexMsg.textContent = text;
      hex.setAttribute('aria-invalid', String(!!text));
    }
    /* Pinta el panel para la capa seleccionada (o lo oculta si no es un texto). */
    function sync() {
      var l = ed.selected();
      panel.hidden = !l || l.type !== 'text' || !!ed.lockReason();
      if (panel.hidden) return;
      q('[data-cte-textp-title]').textContent = 'Texto seleccionado · «' + (l.text || '') + '»';
      var t = q('[data-cte-text]');
      if (document.activeElement !== t) t.value = l.text;
      renderFonts(l.fontKey);
      var color = normalize(l.color), sw = q('[data-cte-tcolors]');
      /* se pintan una vez y solo cambia la marcada: si se repintan al salir del campo HEX (change), el clic en una
         muestra cae en un botón que ya no existe */
      if (!sw.children.length) sw.innerHTML = UI.textColors(QUICK_COLORS, color);
      Array.prototype.forEach.call(sw.children, function (b) {
        var on = b.dataset.cteTcolor.toUpperCase() === color;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', String(on));
      });
      if (document.activeElement !== hex) { hex.value = color; setHexMsg(''); }
      chip.style.background = color;
    }
    function pickFont(key) {
      var l = ed.selected(), f = F.get(key);
      if (!l || !f) return;
      ed.patchLayer(l.id, { fontKey: f.key, family: f.family, weight: f.weight });
      F.ensure(f.key, l.text).then(ed.fontLoaded, function (err) { ed.announce(err.message); });
    }
    function setColor(c) {
      var l = ed.selected();
      if (l) ed.patchLayer(l.id, { color: c });
    }

    panel.addEventListener('click', function (e) {
      var el;
      if ((el = e.target.closest('[data-cte-fontkey]'))) return pickFont(el.dataset.cteFontkey);
      if ((el = e.target.closest('[data-cte-tcolor]'))) return setColor(el.dataset.cteTcolor);
      if (e.target.closest('[data-cte-fonts-all]')) { showAll = !showAll; fontsKey = ''; sync(); }
    });
    panel.addEventListener('input', function (e) {
      var l = ed.selected();
      if (!l) return;
      if (e.target.matches('[data-cte-text]')) {
        ed.patchLayer(l.id, { text: e.target.value });
        /* letras nuevas (acentos, ñ…) pueden estar en otro recorte de la fuente */
        F.ensure(l.fontKey, e.target.value).then(ed.fontLoaded, function () {});
        return;
      }
      if (e.target.matches('[data-cte-hex]')) {
        /* mientras se escribe solo se aplica con 6 cifras ("#E11" sería #EE1111); el formato corto, al confirmar */
        var c = /^#?[0-9a-f]{6}$/i.test(e.target.value.trim()) ? parseHex(e.target.value) : null;
        chip.style.background = c || 'transparent';
        if (c) { setHexMsg(''); setColor(c); }
      }
    });
    hex.addEventListener('change', function () {
      var c = parseHex(hex.value);
      if (!c) return setHexMsg('Escribe un color HEX válido, por ejemplo #E2211C.');
      hex.value = c;
      setHexMsg('');
      setColor(c);
    });
    hex.addEventListener('blur', function () { if (!hexMsg.hidden) return; var l = ed.selected(); if (l) hex.value = normalize(l.color); });
    return { sync: sync };
  }

  var api = { QUICK_COLORS: QUICK_COLORS, parseHex: parseHex, attach: attach };
  if (typeof module === 'object' && module.exports) module.exports = api;
  else global.CorexTextilText = api;
})(this);
